module.exports = __webpack_public_path__ + "img/arrow_full_left.f552e938.svg";